// -----------------------------------------------------------------------------
// PLUGINS/INLINE
// -----------------------------------------------------------------------------
import { keymap } from "prosemirror-keymap";
import { history } from "prosemirror-history";
import { baseKeymap } from "prosemirror-commands";
import { dropCursor } from "prosemirror-dropcursor";
import { Schema } from "prosemirror-model";
import { EditorState } from "prosemirror-state";
import { EditorView } from "prosemirror-view";
// -----------------------------------------------------------------------------
import { paragraph, text, em, strong } from "../schema";
import { buildKeymap } from "../plugins/keymap";
import { buildInputRules } from "../plugins/inputrules";
import { menuPlugin } from "../plugins/menu";
import { elmPlugin } from "../plugins/elm";
import items from "../menu/elems";
// -----------------------------------------------------------------------------
export function inlineEditor(container, id, doc, app) {
    container.inner.classList.add("df-ed--inline");
    const schema = inlineSchema();
    const config = {
        schema: schema,
        plugins: plugins(container, schema, id, app)
    };
    if (doc) {
        return new EditorView(container.inner, {
            state: EditorState.create({
                doc: schema.nodeFromJSON(doc),
                plugins: config.plugins
            })
        });
    }
    else {
        return new EditorView(container.inner, {
            state: EditorState.create(config)
        });
    }
}
export function inlineSchema() {
    return new Schema({
        nodes: { doc: { content: "paragraph" }, paragraph, text },
        marks: { em, strong }
    });
}
function plugins(containers, schema, id, app) {
    return [
        menuPlugin(containers, [items.em, items.strong], true, id, app),
        buildInputRules(schema),
        keymap(buildKeymap(schema)),
        keymap(baseKeymap),
        dropCursor(),
        history(),
        elmPlugin(id, app)
    ];
}
